/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemAnswerTextCorrectionViewModel } from "../types/ExamItemAnswerTextCorrectionViewModel.ts";
import { eComponentTypeSchema } from "./eComponentTypeSchema.ts";

export const examItemAnswerTextCorrectionViewModelSchema = z.object({
  classroomDisciplineCompanyId: z
    .number()
    .int()
    .describe("ID da empresa vinculada à disciplina da turma. Opcional.")
    .nullish(),
  examPublishId: z.optional(
    z
      .number()
      .int()
      .describe("ID da publicação da prova à qual a resposta pertence."),
  ),
  examItemId: z.optional(
    z
      .number()
      .int()
      .describe("ID do item (questão) da prova que foi respondido."),
  ),
  answerId: z
    .number()
    .int()
    .describe("ID da resposta dissertativa do aluno a ser corrigida."),
  label: z
    .string()
    .describe("Enunciado da questão dissertativa (pode conter HTML). Opcional.")
    .nullish(),
  filePath: z
    .string()
    .describe(
      "Caminho do arquivo de resposta enviado pelo aluno, quando aplicável. Opcional.",
    )
    .nullish(),
  isFileImage: z.optional(
    z.boolean().describe("Indica se o arquivo de resposta é uma imagem."),
  ),
  information: z
    .string()
    .describe(
      "Informações adicionais sobre a questão ou resposta, exibidas ao professor correto. Opcional.",
    )
    .nullish(),
  author: z
    .string()
    .describe("Nome do autor/criador da questão dissertativa. Opcional.")
    .nullish(),
  student: z
    .string()
    .describe("Nome do aluno que enviou a resposta. Opcional.")
    .nullish(),
  value: z
    .string()
    .describe("Conteúdo da resposta dissertativa enviada pelo aluno. Opcional.")
    .nullish(),
  completness: z
    .number()
    .describe(
      "Nota de completude atribuída pelo professor à resposta do aluno.",
    ),
  comment: z
    .string()
    .describe("Comentário do professor sobre a resposta corrigida. Opcional.")
    .nullish(),
  gradePerson: z
    .number()
    .int()
    .describe("ID da pessoa (professor/correto) que atribuiu a nota. Opcional.")
    .nullish(),
  gradePersonName: z
    .string()
    .describe(
      "Nome da pessoa (professor/correto) que atribuiu a nota. Opcional.",
    )
    .nullish(),
  hasNext: z.optional(
    z
      .boolean()
      .describe(
        "Indica se existe uma próxima resposta pendente de correção para a mesma questão.",
      ),
  ),
  componentType: z.optional(
    z
      .lazy(() => eComponentTypeSchema)
      .describe(
        "1 = SingleChoice | 2 = MultipleChoice | 3 = SingleLineText | 4 = MultilineText | 5 = Numeric | 6 = Grade | 7 = Audio | 8 = Attachment | ",
      ),
  ),
  isAiAssisted: z.optional(
    z
      .boolean()
      .describe(
        "Indica que o corretor consultou a sugestão de IA antes de submeter esta correção. Quando omitido ou false, a correção é considerada puramente manual.",
      ),
  ),
  subtype: z
    .number()
    .int()
    .describe(
      "Subtipo da questão dissertativa. Presente apenas para questões MultilineText com subtipo cadastrado. Opcional. Enum EExamItemSubtype: `1` = OpinionArticle, `2` = Essay, `3` = ModelAnswerEssay, `4` = MbaCase.",
    )
    .nullish(),
  modelAnswer: z
    .string()
    .describe(
      "Resposta-modelo ou notas de ensino cadastradas na questão, usadas como referência pelo corretor. Opcional.",
    )
    .nullish(),
  keyTerms: z
    .string()
    .describe(
      "Palavras-chave esperadas na resposta, separadas por vírgula. Disponível para o subtipo ModelAnswerEssay. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<ExamItemAnswerTextCorrectionViewModel>;
